import './src/clever-ui-kit/style/constants/normalize.css'
import './src/clever-ui-kit/style/constants/style.css'
import './static/fonts/fonts.css'
import React from 'react'
import ContextProvider from './src/context'
import Layout from './src/components/layout'

export const wrapRootElement = ({ element }) => (
  <ContextProvider>
    <Layout>{element}</Layout>
  </ContextProvider>
)
